import { type AccessorialCharge } from './QuoteAccessorial'

export type DraftQuote = {
  uuid?: string
  flatRate?: number
  notes?: string
  accessorials?: Array<AccessorialCharge>
}

export function getQuotesToSubmit(draftQuotes: Record<string, DraftQuote>): Array<DraftQuote> {
  return Object.keys(draftQuotes)
    .filter(key => (draftQuotes[key].flatRate ?? 0) > 0)
    .map(key => {
      const { flatRate, notes, accessorials } = draftQuotes[key]

      return {
        uuid: key,
        flatRate,
        notes,
        accessorials,
      }
    })
}
